import axios, { AxiosError, AxiosResponse } from "axios"
import api, {  } from "../../services/api.service"
import { IResponseApplicationNumber, IResponseCourseName, IResponseLogin, IResponseProgramInfo } from "./login.type"

const route = '/auth'
axios.defaults.withCredentials = true


/** Отправка формы */
export const auth = async (verifCode: number, typeForm: string, name: string, phone: string, courseID: string, courseProgramID: string, files: File[]): Promise<IResponseLogin> => {
    let response: IResponseLogin

    try {
        const res: AxiosResponse<IResponseLogin, AxiosError> = await api.post(`${route}/login`, { verifCode, typeForm, name, phone, courseID, courseProgramID, docs: files }, { headers: { "Content-Type": `multipart/form-data` } })
        
        if (res.statusText !== 'ERR_NETWORK') {
            response = res.data
        } else {
            response = {
                status: 500, 
                message: 'Сервер временно не доступен.',
                errors: null
            }
        }

        return response
    } catch (error) {
        if ((error as AxiosError).code === 'ERR_NETWORK') {response = {status: 500, message: 'Сервер не доступен', errors: (error as AxiosError).code}; return response}

        const resError = (error as AxiosError).response?.data as IResponseLogin
        response = {status: 500, message: resError?.message, errors: resError.errors}
        return response
    }
}

/**  */
export const getCourseName = async (courseID: string) => {
    let response: IResponseCourseName

    try {
        const res: AxiosResponse<IResponseCourseName, AxiosError> = await api.get(`${route}/getCourseName`, {params: {courseID}})

        if (res.statusText !== 'ERR_NETWORK') {
            response = res.data
        } else {
            response = {
                status: 500, 
                message: 'Сервер временно не доступен.',
                errors: null
            }
        }

        return response
    } catch(error) {
        if ((error as AxiosError).code === 'ERR_NETWORK') {response = {status: 500, message: 'Сервер не доступен', errors: (error as AxiosError).code}; return response}

        const resError = (error as AxiosError).response?.data as IResponseCourseName
        response = {status: 500, message: resError?.message, errors: resError.errors}
        return response
    }
}

/**  */
export const getProgramInfo = async (courseProgramID: string) => {
    let response: IResponseProgramInfo

    try {
        const res: AxiosResponse<IResponseProgramInfo, AxiosError> = await api.get(`${route}/getProgramInfo`, {params: {courseProgramID}})

        if (res.statusText !== 'ERR_NETWORK') {
            response = res.data
        } else {
            response = {
                status: 500, 
                message: 'Сервер временно не доступен.',
                errors: null
            }
        }

        return response
    } catch(error) {
        if ((error as AxiosError).code === 'ERR_NETWORK') {response = {status: 500, message: 'Сервер не доступен', errors: (error as AxiosError).code}; return response}

        const resError = (error as AxiosError).response?.data as IResponseProgramInfo
        response = {status: 500, message: resError?.message, errors: resError.errors}
        return response
    }
}

/**  */
export const getApplicationNumber = async (phoneNumber: string) => {
    let response: IResponseApplicationNumber

    try {
        const res: AxiosResponse<IResponseApplicationNumber, AxiosError> = await api.get(`${route}/getApplicationNumber`, {params: {phoneNumber}})

        if (res.statusText !== 'ERR_NETWORK') {
            response = res.data
        } else {
            response = {
                status: 500, 
                message: 'Сервер временно не доступен.',
                errors: null
            }
        }

        return response
    } catch(error) {
        if ((error as AxiosError).code === 'ERR_NETWORK') {response = {status: 500, message: 'Сервер не доступен', errors: (error as AxiosError).code}; return response}

        const resError = (error as AxiosError).response?.data as IResponseApplicationNumber
        response = {status: 500, message: resError?.message, errors: resError.errors}
        return response
    }
}
